// src/components/LoginPage.vue

<template>
  <v-container>
    <h1 class="welcome-text">Welcome to Bail Bond Agent Services</h1>
    <p class="sign-in-text" v-if="isUserLoggedIn">You are signed in. Make a selection from the menu.</p>
    <p class="sign-in-text" v-else>Sign in to continue.</p>

    <h1>&nbsp;</h1>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoginPage',
  data() {
    return {
      phoneNumber: '',
      consentChecked: false,
    };
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'isUserLoggedIn',
    }),
  },
  methods: {
   saveSettings() {
      // Log the current values
      console.log('Saving settings:', {
        phoneNumber: this.phoneNumber,
        consentChecked: this.consentChecked,
      });
      
      // Clear the phone number field
      this.phoneNumber = '';
    }
  }
};

</script>

<style scoped>
.welcome-text {
  font-size: 48px;
  color: #635347;
}

.sign-in-text {
  font-size: 24px;
  color: gray;
}

.privacy-section {
  margin-top: 2rem;
  max-width: 600px;
}

.privacy-header {
  font-size: 24px;
  color: #635347;
  margin-bottom: 1rem;
}

.consent-text {
  font-size: 14px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
}

.consent-section {
  margin-top: 1rem;
}
</style>

